<template>
    <div :key="data_key">
        <vx-card class="mb-5 overflow-hidden" v-for="(redem, index) in redemtionData" :key="index" :class="{'is-selected': redem.checked}">
            <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default p-3 py-4">
                <!-- <input type="checkbox" class="vs-checkbox--input" :id="redem.id" v-model="redem.checked" @click="addRedemtion(redem)"> -->
                <input type="checkbox" class="vs-checkbox--input" :id="redem.id" :checked="redem.checked" @click="addRedemtion(redem)">
                <span class="checkbox_x vs-checkbox" style="border: 2px solid rgb(180, 180, 180);">
                    <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
                </span>
                <span class="con-slot-label">
                    <div class="title pl-4">{{redem.content}}</div>
                </span>
            </div>
        </vx-card>
    </div>
</template>
<script>
export default {
    name: 'checkout-redeem',
    props:{
      popupConfigRedemtion:{
        type: Object,
        required: true
      },
      redemtionData: {
        type: Array,
        required: true
      }
    },
    data(){
      return {
        data_key: 0
      }
    },
    watch: {
      redemtionData: {
        immediate: true,
        deep: true,
        handler() {
          this.data_key++;
        }
      }
    },
    // mounted() {
    //   let elem = document.getElementsByClassName('vs-checkbox--input');
    //   if(elem && elem.length) {
    //     for(let i = 0; i < elem.length; i++) {
    //       elem[i].addEventListener('touchstart', () => {});
    //       elem[i].addEventListener('touchend', () => {});
    //       elem[i].addEventListener('touchcancel', () => {});
    //       elem[i].addEventListener('touchmove', () => {});
    //     }
    //   }
    // },
    methods: {
      changeStatusCheckBox(item) {
        this.$store.dispatch('checkin/CHANGE_STATUS_REDEMPTION', item);
      },
      addRedemtion(redem){
        this.changeStatusCheckBox(redem);
        this.$emit("AddRedemtion" , redem);
      }
    },
}
</script>
